// Copied from
// https://github.com/axios/axios/blob/master/lib/helpers/buildURL.js
import utils from "axios/lib/utils";
import * as _ from "lodash-es";

function encode(val) {
  return encodeURIComponent(val)
    .replace(/%40/gi, "@")
    .replace(/%3A/gi, ":")
    .replace(/%24/g, "$")
    .replace(/%2C/gi, ",")
    .replace(/%20/g, "+")
    .replace(/%5B/gi, "[")
    .replace(/%5D/gi, "]");
}

// 'django-filters' package skips empty strings.
// Null values are skipped by default, but it's configurable.
// https://django-filter.readthedocs.io/en/stable/guide/tips.html#filtering-by-empty-values
// https://django-filter.readthedocs.io/en/stable/guide/tips.html#filtering-by-an-empty-string
export const excludeParam = (value) => _.isNil(value) || value === "";

export const excludeFilter = (value) =>
  excludeParam(value) ||
  // Don't include empty arrays
  (Array.isArray(value) && !value.length);

export const paramsSerializer = (params) => {
  const parts = [];

  utils.forEach(params, function serialize(val, key) {
    if (excludeParam(val)) {
      return;
    }

    if (utils.isArray(val)) {
      // FIXED: django don't requires empty brakets in filter variable name.
      // key = key + '[]';
    } else {
      val = [val];
    }

    utils.forEach(val, function parseValue(v) {
      if (utils.isDate(v)) {
        v = v.toISOString();
      } else if (utils.isObject(v)) {
        v = JSON.stringify(v);
      }
      parts.push(encode(key) + "=" + encode(v));
    });
  });

  return parts.join("&");
};
